import { render, staticRenderFns } from "./ApproveModal.vue?vue&type=template&id=0f170250"
import script from "./ApproveModal.vue?vue&type=script&lang=ts"
export * from "./ApproveModal.vue?vue&type=script&lang=ts"
import style0 from "./ApproveModal.vue?vue&type=style&index=0&id=0f170250&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports